module.exports = __webpack_public_path__ + "img/study-design.c561f1c0.png";